import { LEGAL_INFO } from './legal-info';
import { LegalLayout } from './LegalLayout';

export function CgvPage() {
  return (
    <LegalLayout
      title="Conditions Générales de Vente"
      subtitle={`Contrat d'abonnement au service « ${LEGAL_INFO.productName} » entre professionnels (B2B).`}
    >
      <section>
        <h2>Article 1 — Objet</h2>
        <p>
          Les présentes Conditions Générales de Vente (ci-après les « <strong>CGV</strong> »)
          régissent les relations contractuelles entre {LEGAL_INFO.companyName} (ci-après l'«{' '}
          <strong>Éditeur</strong> ») et toute personne morale souscrivant un abonnement au service
          « {LEGAL_INFO.productName} » (ci-après le « <strong>Service</strong> » et le «{' '}
          <strong>Client</strong> »).
        </p>
        <p>
          Le Service est une {LEGAL_INFO.productDescription} accessible en ligne en mode SaaS
          (Software as a Service). Les fonctionnalités détaillées sont décrites sur{' '}
          <a href={LEGAL_INFO.websiteUrl} target="_blank" rel="noopener noreferrer">
            {LEGAL_INFO.websiteUrl}
          </a>{' '}
          et peuvent évoluer.
        </p>
        <p>
          Toute souscription implique l'acceptation sans réserve des présentes CGV par le Client,
          qui reconnaît en avoir pris connaissance préalablement à la souscription.
        </p>
      </section>

      <section>
        <h2>Article 2 — Souscription</h2>
        <p>
          La souscription au Service s'effectue par signature d'un bon de commande, d'un devis
          accepté ou par création d'un compte en ligne suivie d'une validation des présentes CGV.
        </p>
        <p>
          Le Service est exclusivement destiné aux professionnels (B2B). Le Client garantit agir
          dans le cadre de son activité professionnelle et disposer du pouvoir d'engager la personne
          morale qu'il représente.
        </p>
      </section>

      <section>
        <h2>Article 3 — Prix et modalités de paiement</h2>
        <h3>3.1 Prix</h3>
        <p>
          Les prix de l'abonnement sont indiqués dans le devis ou sur la grille tarifaire en vigueur
          au jour de la souscription. Ils sont exprimés en euros, hors taxes. La TVA applicable est
          ajoutée selon la législation en vigueur.
        </p>
        <h3>3.2 Modalités</h3>
        <p>
          L'abonnement est facturé d'avance, par période mensuelle ou annuelle selon le plan choisi.
          Le paiement est exigible à réception de facture, par prélèvement automatique, virement ou
          carte bancaire.
        </p>
        <h3>3.3 Retard de paiement</h3>
        <p>
          Conformément à l'article L. 441-10 du Code de commerce, tout retard de paiement entraîne
          de plein droit, sans mise en demeure préalable, l'application de pénalités de retard
          calculées au taux de la BCE majoré de 10 points, ainsi qu'une indemnité forfaitaire pour
          frais de recouvrement de 40 €. L'Éditeur se réserve la possibilité de suspendre l'accès au
          Service en cas d'impayé après mise en demeure restée infructueuse pendant 15 jours.
        </p>
      </section>

      <section>
        <h2>Article 4 — Durée, reconduction et résiliation</h2>
        <h3>4.1 Durée</h3>
        <p>
          L'abonnement est souscrit pour la durée indiquée dans le devis ou sur le formulaire de
          souscription (typiquement 1 mois ou 12 mois). À défaut, la durée par défaut est d'un (1)
          mois.
        </p>
        <h3>4.2 Reconduction tacite</h3>
        <p>
          L'abonnement est reconduit tacitement par périodes de même durée, sauf résiliation par
          l'une des parties dans les conditions ci-dessous.
        </p>
        <h3>4.3 Résiliation à échéance</h3>
        <p>
          Chaque partie peut résilier l'abonnement à l'échéance en notifiant sa décision par e-mail
          à <a href={`mailto:${LEGAL_INFO.contactEmail}`}>{LEGAL_INFO.contactEmail}</a> au plus tard
          quinze (15) jours avant l'échéance pour les abonnements mensuels, ou trente (30) jours
          avant l'échéance pour les abonnements annuels.
        </p>
        <h3>4.4 Résiliation pour manquement</h3>
        <p>
          En cas de manquement grave de l'une des parties à ses obligations, non régularisé dans un
          délai de trente (30) jours à compter de la mise en demeure adressée par lettre
          recommandée, l'autre partie peut résilier le contrat de plein droit, sans préjudice de
          tous dommages et intérêts.
        </p>
        <h3>4.5 Effets de la résiliation</h3>
        <p>
          À la résiliation, l'accès au Service est désactivé. Les données du Client restent
          disponibles à l'export pendant trente (30) jours via la fonctionnalité prévue à cet effet,
          puis sont supprimées définitivement (voir article 8). Les sommes dues restent exigibles.
        </p>
      </section>

      <section>
        <h2>Article 5 — Obligations de l'Éditeur</h2>
        <p>L'Éditeur s'engage à :</p>
        <ul>
          <li>fournir le Service conformément à sa documentation ;</li>
          <li>
            mettre en œuvre les moyens techniques raisonnables pour assurer la disponibilité, la
            sécurité et l'intégrité du Service ;
          </li>
          <li>
            informer le Client des opérations de maintenance planifiées avec un préavis raisonnable
            ;
          </li>
          <li>
            assurer le traitement des données à caractère personnel en qualité de sous-traitant,
            conformément à l'accord de traitement des données (DPA, voir article 8) ;
          </li>
          <li>
            fournir un support technique aux jours et heures ouvrés convenus dans le contrat de
            service.
          </li>
        </ul>
        <p>
          L'Éditeur est tenu à une obligation de moyens et non de résultat. Il ne saurait être tenu
          pour responsable des interruptions liées à des cas de force majeure, à des défaillances
          d'infrastructures tierces (hébergeur, fournisseurs d'accès) ou à des actes du Client ou de
          tiers.
        </p>
      </section>

      <section>
        <h2>Article 6 — Obligations du Client</h2>
        <p>Le Client s'engage à :</p>
        <ul>
          <li>
            utiliser le Service conformément à sa destination et aux{' '}
            <a href="/legal/cgu">Conditions Générales d'Utilisation</a> ;
          </li>
          <li>fournir des informations exactes lors de la souscription et les tenir à jour ;</li>
          <li>
            préserver la confidentialité de ses identifiants de connexion ; toute action effectuée
            avec ses identifiants est réputée provenir du Client ;
          </li>
          <li>
            ne pas porter atteinte à l'intégrité du Service (intrusion, contournement de sécurité,
            tests de charge non autorisés, etc.) ;
          </li>
          <li>payer les sommes dues aux échéances convenues ;</li>
          <li>
            respecter la réglementation applicable, notamment le RGPD pour les données qu'il traite
            via le Service.
          </li>
        </ul>
      </section>

      <section>
        <h2>Article 7 — Disponibilité et niveau de service (SLA)</h2>
        <p>
          L'Éditeur s'efforce d'assurer une disponibilité du Service de <strong>99,5 %</strong>{' '}
          mensuels, hors maintenances planifiées et cas de force majeure. Les maintenances
          planifiées sont annoncées au moins quarante-huit (48) heures à l'avance et privilégient
          les plages horaires à faible activité.
        </p>
        <p>
          En cas de manquement avéré à ce niveau de service, le Client peut demander un avoir au
          prorata de la durée d'indisponibilité constatée, plafonné à un (1) mois d'abonnement par
          année civile. Cet avoir constitue la seule indemnisation due à ce titre.
        </p>
      </section>

      <section>
        <h2>Article 8 — Données et confidentialité</h2>
        <p>
          Le traitement des données à caractère personnel par l'Éditeur, en qualité de sous-traitant
          au sens de l'article 28 du RGPD, est régi par un accord de traitement des données (DPA)
          mis à disposition du Client sur simple demande à{' '}
          <a href={`mailto:${LEGAL_INFO.contactEmail}`}>{LEGAL_INFO.contactEmail}</a>.
        </p>
        <p>
          Chaque partie s'engage à préserver la confidentialité des informations non publiques
          échangées dans le cadre de la relation contractuelle, pendant toute sa durée et pendant
          trois (3) ans après son terme.
        </p>
        <p>
          À la résiliation, le Client dispose d'un délai de trente (30) jours pour exporter ses
          données via la fonctionnalité dédiée du Service. Passé ce délai, les données sont
          supprimées définitivement, sauf obligation légale de conservation (notamment comptable).
        </p>
      </section>

      <section>
        <h2>Article 9 — Propriété intellectuelle</h2>
        <p>
          L'Éditeur conserve l'entière propriété intellectuelle du Service, de son code source, de
          sa documentation, de son interface et de ses marques. L'abonnement confère au Client un
          droit personnel, non exclusif et non transférable d'utilisation du Service pendant la
          durée de l'abonnement, dans la limite du nombre d'utilisateurs souscrits.
        </p>
        <p>
          Les données et contenus que le Client transmet via le Service demeurent sa propriété
          exclusive. Le Client concède à l'Éditeur les droits strictement nécessaires à la
          fourniture du Service (stockage, traitement, affichage).
        </p>
      </section>

      <section>
        <h2>Article 10 — Responsabilité et limitation</h2>
        <p>
          La responsabilité de l'Éditeur est limitée aux dommages directs prévisibles. En aucun cas
          l'Éditeur ne pourra être tenu pour responsable des dommages indirects, et notamment de
          tout préjudice commercial, perte de chiffre d'affaires, perte de clientèle, atteinte à
          l'image ou perte de données ne lui étant pas directement imputable.
        </p>
        <p>
          En tout état de cause, et sauf en cas de faute lourde ou dolosive, la responsabilité
          cumulée de l'Éditeur à raison de l'exécution du présent contrat est plafonnée au montant
          des sommes effectivement perçues du Client au titre des douze (12) mois précédant le fait
          générateur du dommage.
        </p>
      </section>

      <section>
        <h2>Article 11 — Force majeure</h2>
        <p>
          Aucune des parties ne peut être tenue pour responsable de l'inexécution de ses obligations
          en cas de force majeure au sens de l'article 1218 du Code civil, ce qui inclut notamment,
          sans s'y limiter : les défaillances majeures des réseaux publics, les actes de
          cyberattaque rendant le Service indisponible malgré les mesures de sécurité mises en
          œuvre, les décisions des autorités publiques.
        </p>
      </section>

      <section>
        <h2>Article 12 — Sous-traitance</h2>
        <p>
          L'Éditeur peut faire appel à des sous-traitants ultérieurs pour l'exécution du Service
          (notamment l'hébergeur). La liste des sous-traitants est précisée dans le DPA. Toute
          modification substantielle est notifiée au Client, qui dispose d'un droit d'opposition
          motivé dans un délai de trente (30) jours.
        </p>
      </section>

      <section>
        <h2>Article 13 — Évolution des CGV</h2>
        <p>
          L'Éditeur se réserve la possibilité de modifier les présentes CGV. Toute modification
          substantielle est notifiée au Client avec un préavis de trente (30) jours. Le Client qui
          n'accepterait pas les nouvelles CGV peut résilier l'abonnement sans frais et sans pénalité
          avant la prise d'effet des nouvelles CGV.
        </p>
      </section>

      <section>
        <h2>Article 14 — Droit applicable et juridiction</h2>
        <p>
          Les présentes CGV sont soumises au droit français. En cas de litige et à défaut d'accord
          amiable, le différend sera soumis à la compétence exclusive du {LEGAL_INFO.jurisdiction},
          nonobstant pluralité de défendeurs ou appel en garantie.
        </p>
      </section>
    </LegalLayout>
  );
}
